export const WALLET_BALANCE = "WALLET_BALANCE";
export const FETCH_WALLET_BALANCE = "FETCH_WALLET_BALANCE";